import { useUserContext } from "../../context/user/user-context";
import type { Permission } from "../../types";

export const useAuthState = () => {
  const { token, user } = useUserContext();
  return {
    token,
    getRole: () => user.role,
    checkPermission: (requiredPermission: Permission) => requiredPermission >= user.role
  };
};
